/*
 * Module handling the quick response editor modal.  Extended from the regular topic response editor.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponseEditorModal/topicResponseEditorModalModule",
  "modules/quickCreate/quickResponseModal/quickResponseModalView",
], function (Marionette, Messenger, TopicResponseEditorModalModule, QuickResponseModalView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "quickResponseModal";
      this.region = options.region;
      this._setUpReqres();
      this._setUpVents();
    },
    show: function (conversationBundlePlusQuickCreate) {
      //insert touchpoint and language info into the bundle
      var touchpoint = Messenger.reqres.request("default:touchpoint");
      var language = Messenger.reqres.request("default:response:language");
      conversationBundlePlusQuickCreate.selectedTouchPoint = touchpoint;
      conversationBundlePlusQuickCreate.selectedLanguage = language;
      conversationBundlePlusQuickCreate.skipCollaborationFeatures = true;
      this.quickCreate = conversationBundlePlusQuickCreate.quickCreate;
      this.topic = conversationBundlePlusQuickCreate.topic;
      this.layout = new QuickResponseModalView.quickResponseModalLayout({
        model: this.quickCreate,
      });
      this.editor = this.addSubModule(
        new TopicResponseEditorModalModule({ region: this.layout.editor }),
      );

      this.layout.on(
        "show",
        function () {
          conversationBundlePlusQuickCreate.node.onSynced(function () {
            this.editor.show(conversationBundlePlusQuickCreate);
          }, this);
        },
        this,
      );
      this.showRegion(this.layout, {
        loading: true,
        entity: conversationBundlePlusQuickCreate.node,
      });
    },
    _setUpReqres: function () {
      Messenger.reqres.setHandler("current:topic", () => this.topic, this);
      Messenger.reqres.setHandler("current:topic:id", () => this.topic.id, this);
      Messenger.reqres.setHandler("current:topic:status", () => this.topic.get("statusId"), this);
    },
    _setUpVents: function () {
      //This is what the response editor fires when the "done" button is pressed.  We should update the quick create model
      //based on the state of the 'mark as completed' checkbox and whether the response was changed.
      Messenger.vent.on(
        "selected:node",
        function (node) {
          //if the completed checkbox is enabled, the set component as completed
          if (this.layout.getCompleteness()) {
            this.quickCreate.set("responseComponent", 2);
          } else if (this.quickCreate.get("responseComponent") === 2 || node.dirty) {
            //the checkbox is not checked.  If the component was completed or if the node is dirty, set the component as 'started'.
            this.quickCreate.set("responseComponent", 1);
          } //otherwise, leave it alone.
        },
        this,
      );
    },
  });
});
